import RouteChoice from "../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../ts/manager/Manager";
import RouteChoiceButton from "./button/RouteChoiceButton";
import React from "react";

interface Props
{
    choiceList:RouteChoice[]
    limit?:number
}

const RoutePagination = (props: Props) =>
{

    const limit = Math.max(props.limit || 7, 7);
    let displayChoiceList:(RouteChoice|null)[] = [];
    if(props.choiceList.length <= limit){
        displayChoiceList = props.choiceList;
    } else {
        const activeHref = getManager().navigation.model.href;
        let selectedIndex = -1;
        for(let i = 0; i < props.choiceList.length; i++){
            const choice = props.choiceList[i];
            if(choice.getHref() === activeHref){
                selectedIndex = i;
                break;
            }
        }
        const midPointIndex = Math.ceil(limit / 2) - 1;
        if(selectedIndex <= midPointIndex){
            for(let i = 0 ; i < limit; i++){
                if(i === limit - 1){
                    displayChoiceList.push(props.choiceList[props.choiceList.length - 1]);
                } else if( i === limit - 2 ){
                    displayChoiceList.push(null);
                } else {
                    displayChoiceList.push(props.choiceList[i]);
                }
            }
        } else if(selectedIndex >= ((props.choiceList.length - 1) - (limit - 1 - midPointIndex))){
            for(let i = 0 ; i < limit; i++){
                if(i === 0){
                    displayChoiceList.push(props.choiceList[0]);
                } else if( i === 1 ){
                    displayChoiceList.push(null);
                } else {
                    displayChoiceList.push(props.choiceList[props.choiceList.length - (limit - i)]);
                }
            }
        } else {
            for(let i = selectedIndex; i >= 0; i--){
                let displayIndex = midPointIndex - (selectedIndex - i);
                if(displayIndex < 0){
                    break;
                }
                if(displayIndex === 0){
                    displayChoiceList[displayIndex] = props.choiceList[0];
                } else if(displayIndex === 1 && (displayIndex !== i)){
                    displayChoiceList[displayIndex] = null;
                } else {
                    displayChoiceList[displayIndex] = props.choiceList[i];
                }
            }
            for(let i = selectedIndex + 1; i < props.choiceList.length; i++){
                let displayIndex = midPointIndex + (i - selectedIndex);
                if(displayIndex > limit - 1){
                    break;
                }
                if(displayIndex === limit - 1){
                    displayChoiceList[displayIndex] = props.choiceList[props.choiceList.length - 1];
                } else if(displayIndex === (limit - 2) && (displayIndex !== i)){
                    displayChoiceList[displayIndex] = null;
                } else {
                    displayChoiceList[displayIndex] = props.choiceList[i];
                }
            }
        }

    }

    return <>
        {displayChoiceList.map((choice, index) =>
        {
            if(!choice){
                return <span key={index} className="pagination-item ms-2 ellipses">...</span>
            }
            return <RouteChoiceButton
                key={index}
                routeChoice={choice}
                scrollToPath={choice?.realPath}
                className="btn btn-primary ms-2 pagination-item"
            />
        })}
    </>
}

export default RoutePagination;